import { render } from "./InfinityScroll.vue?vue&type=template&id=5c5d78d3"
import script from "./InfinityScroll.vue?vue&type=script&lang=js"
export * from "./InfinityScroll.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__